/**
 * Created by Elaa on 3/30/2015.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var UsageTrackingModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        UsageTrackingModel = BaseModel.extend({
            defaults: {
            },
            resource: ApiResources.ConnectionPanel.UsageTrackingEvent,
            name: "UsageTrackingModel",

            initialize: function () {
                var isAuthenticated = LE.sessionManager.isAuthenticated();
                this.originalUrl = isAuthenticated ? this.resource.securedUrl : this.resource.url;
            },

            _initializeResource: function (options) {
                if(this._isValidOptions(options)){
                    this.resource.url = this.originalUrl;
                    this.resource.url = this.resource.url.replace("{eventId}", options.eventId);
                    if (options.slug) {
                        this.resource.url = this.resource.url.replace("{slug}", options.slug);
                    }
                    this.resource.url = this.resource.url.replace("{lang}", options.lang);
                    this.resource.url = this.resource.url.replace("{userId}", options.userId);
                    this.resource.url = this.resource.url.replace("{accountId}", options.accountId);
                    this.resource.url = this.resource.url.replace("{persona}", options.persona);
                    this.resource.url = this.resource.url.replace("{isTrial}", options.isTrial);
                }
            },

            _isValidOptions: function (options) {
                var isValid = true;
                if(_.isEmpty(options) || (_.isEmpty(options.eventId)) || (_.isEmpty(options.accountId))) {
                    LEConnection.logger.error("UsageTrackingModel:_isValidOptions:Failed to initialize model with these parameters:", options);
                    LEConnection.logger.graph({name:"connection:UsageTrackingModel:_isValidOptions:fail"});
                    isValid = false;
                }
                return isValid;
            },

            fetch: function(options) {
                options = options || {};
                if(this._isValidOptions(options)){
                    this._initializeResource(options);
                    return BaseModel.prototype.fetch.call(this, options);
                }
            }
        });
    });
    return UsageTrackingModel;
});
